/*
 * @Description:
 * @Author: 作者
 * @Date: 2024-11-26 16:26:23
 */
import { acceptLangMap } from '@/config/constant'
import { useDistributionStore, useUserStore } from '@/stores'
import { USER_STORE_KEY } from '@/stores/config'
import axios from 'axios'
import CryptoJS from 'crypto-js'
import { ElMessage, ElMessageBox } from 'element-plus'
import qs from 'qs'
const NO_DEBUGGER_KEY = '_NO_DEBUGGER_KEY'

// 创建一个 axios 实例
const instance = axios.create({
  timeout: 10000, // 请求超时时间毫秒
  withCredentials: false, // 异步请求携带cookie
  baseURL: '/',
})
let isShowReload = false
//拦截器 请求拦截
instance.interceptors.request.use(
  async (config) => {
    //做点什么----根据后端约定执行相关 这里是判断开发/线上环境 存储添加token
    const localValue = localStorage.getItem(USER_STORE_KEY)
    const userStore = localValue ? JSON.parse(localValue) : {}
    const token = userStore.token
    const lang = userStore.languag
    const store = useUserStore()

    if (config.method && config.method.toUpperCase() === 'GET') {
      config.data && (config.url = `${config.url}?${qs.stringify(config.data)}`)
      config.data = null
    }
    // 为了方便调试 建议在正式换下 对参数进行加密 测试环境不加密
    const isDebugger = localStorage.getItem(NO_DEBUGGER_KEY)
    if (!config.noEncrypt && isDebugger !== NO_DEBUGGER_KEY) {
      const payload = JSON.stringify(config.data)
      const key = CryptoJS.enc.Utf8.parse('abcdefgabcdefg12')
      const srcs = CryptoJS.enc.Utf8.parse(payload)
      const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      })
      config.data = { encrypted: encrypted.toString() }
    }

    //判断是否存在token，根据后端约定在header的authorization都加上token
    if (token) {
      config.headers.Authorization = `${token}`
      if (!isShowReload && store.loginTimer && store.loginTimer != userStore.loginTimer) {
        if (store.profile.userId === userStore?.profile.userId) return
        isShowReload = true
        // eslint-disable-next-line
        const data = require(`@/i18n/langs/${lang}/common.js`).default
        try {
          await ElMessageBox.confirm(data.reloadPageTips, data.tips, {
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            customClass: 'common-confirm',
            confirmButtonText: data.reload,
          })
          location.reload()
          await new Promise()
        } catch (error) {
          await new Promise()
        }
      }
    }
    const registerLang = config.headers['register-lang'] || userStore.language
    config.headers.lang = registerLang
    config.headers.Currency = userStore.currency
    config.headers.device = 'pc'
    config.headers['Accept-Language'] = acceptLangMap[registerLang]
    isDebugger !== NO_DEBUGGER_KEY && (config.headers['X-Encrypted'] = 'true')
    //根据后端约定执行相关 结束
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

//拦截器 响应拦截
instance.interceptors.response.use(
  (response) => {
    if (!response.data) {
      response.data = {
        code: 500,
        msg: 'network error!',
      }
    }
    try {
      if (typeof response.data === 'string') {
        const key = CryptoJS.enc.Utf8.parse('abcdefgabcdefg12')
        response.data = CryptoJS.AES.decrypt(response.data, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        })
        response.data = JSON.parse(response.data.toString(CryptoJS.enc.Utf8))
      }
    } catch (error) {
      return Promise.reject(error)
    }

    //做点什么----根据后端约定状态判断执行 这里是判断状态移除token
    if (response.data.status) {
      //
    } else {
      if (response.data.code !== 200) {
        ElMessage.error(response.data.msg)
      }
      return response.data
    }
    //根据后端约定状态判断执行 结束

    //可将 return response ↑放在做点什么中↑

    return response.data
  },
  (error) => {
    const filterApiArr = ['myFreightShareCouponVO', 'getFreightShareCouponList'] // 分享券相关接口
    const isFilterApi = filterApiArr.some((api) => error?.config?.url?.includes(api))
    if (!isFilterApi) {
      ElMessage.error(error)
    }
    if (error.response?.status === 401 && !isFilterApi) {
      const userStore = useUserStore()
      const distributionStore = useDistributionStore()
      userStore.logout()
      distributionStore.logout()
      if (location.search.includes('redirectUrl')) return
      const redirectUrl = encodeURIComponent(`${location.pathname}${location.search}`)
      location.href = `/login?redirectUrl=${redirectUrl}`

      return
    }

    return error
  },
)

export default instance
